import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import BrIcons from '@components/BrIcons';

export default class BrCopyButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.string,
  };

  static defaultProps = {
    data: '',
  };

  copyToClipboard(str, onClick) {
    if (window.clipboardData && window.clipboardData.setData) {
      clipboardData.setData('Text', str);
      if (onClick) {
        onClick();
      }
    } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
      const textarea = document.createElement('textarea');
      textarea.textContent = str;
      textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy'); // Security exception may be thrown by some browsers.
        if (onClick) {
          onClick();
        }
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Copy to clipboard failed.', ex);
        // eslint-disable-next-line no-alert
        alert('Copy failed!');
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  render() {
    const { data } = this.props;

    return (
      <div onClick={() => this.copyToClipboard(data, null)}>
        <BrIcons.Copy />
      </div>
    );
  }
}
